import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import * as authActionCreators from '../../actions/auth';
import * as commonActionCreators from '../../actions/common';
let allActionCreators = Object.assign({}, authActionCreators, commonActionCreators);

import {ContactContainer} from '../views/contact/Contact';
import {ContactNoItemContainer} from '../views/contact/ContactNoItem';
import {HeaderContainer} from '../views/header/Header';
import {InviteContainer} from '../views/invite/Invite';
import Footer from '../views/footer/Footer';
import RhinoAlert from './alert/RhinoAlert';


class AppAuth extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <div className='AppAuth'>
      <HeaderContainer />
      <div className='authBody'>
        {this.props.children}
      </div>
      <InviteContainer />
      <ContactContainer />
      <ContactNoItemContainer />
      <RhinoAlert open={this.props.common.alertOpen} alertText={this.props.common.alertText} closeText={this.props.common.alertPrompt} closeMethod={::this.props.commonCloseAlert} />
    </div>;
  }
}
export default AppAuth;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    common: state.common,
  };
}

export const AppAuthContainer = connect(
  mapStateToProps,
  allActionCreators
)(AppAuth);




// WEBPACK FOOTER //
// ./src/components/common/AppAuth.jsx